import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { type Observable, firstValueFrom, map } from 'rxjs';
import { API_BASE_URL } from '@shared/http';
import {
  BuildLimitOrderResultSchema,
  LimitOrderListSchema,
  LimitOrderSchema,
  type BuildLimitOrderDto,
  type BuildLimitOrderResult,
  type LimitOrder,
} from '../model/order.schema';

@Injectable({ providedIn: 'root' })
export class OrderApi {
  private readonly base = inject(API_BASE_URL);
  private readonly http = inject(HttpClient);

  list$(): Observable<LimitOrder[]> {
    return this.http
      .get<unknown>(`${this.base}/me/trading/limit-orders`)
      .pipe(map(raw => LimitOrderListSchema.parse(raw)));
  }

  async create(dto: BuildLimitOrderDto, freshToken?: string): Promise<BuildLimitOrderResult> {
    const options = freshToken
      ? { headers: new HttpHeaders({ 'x-fresh-token': freshToken }) }
      : undefined;
    const raw = await firstValueFrom(
      this.http.post<unknown>(`${this.base}/me/trading/limit-orders`, dto, options),
    );
    return BuildLimitOrderResultSchema.parse(raw);
  }

  async submit(localOrderId: string, freshToken: string): Promise<LimitOrder> {
    return firstValueFrom(
      this.http
        .post<unknown>(
          `${this.base}/me/trading/limit-orders/${localOrderId}/submit`,
          {},
          { headers: new HttpHeaders({ 'x-fresh-token': freshToken }) },
        )
        .pipe(map(raw => LimitOrderSchema.parse(raw))),
    );
  }

  async cancel(localOrderId: string): Promise<void> {
    await firstValueFrom(this.http.delete(`${this.base}/me/trading/limit-orders/${localOrderId}`));
  }
}
